import { useCallback, useEffect, useId, useRef, useState, useSyncExternalStore } from 'react';
import { audioCoordinator } from './audioCoordinator';

const serverVoice = () => null;
const useVoiceOwner = () => useSyncExternalStore(audioCoordinator.subscribe, audioCoordinator.getVoice, serverVoice);

export function useVoiceDemo() {
  const id = useId();
  const owner = useVoiceOwner();
  useEffect(() => () => audioCoordinator.closeVoice(id), [id]);
  return {
    open: owner === id,
    toggle: () => audioCoordinator.getVoice() === id ? audioCoordinator.closeVoice(id) : audioCoordinator.openVoice(id),
    close: () => audioCoordinator.closeVoice(id),
  };
}

export function useExclusiveAudio() {
  const id = useId();
  const videoRef = useRef(null);
  const unregister = useRef(null);
  const [isMuted, setMuted] = useState(true);
  const owner = useVoiceOwner();
  const setVideoRef = useCallback(element => {
    unregister.current?.();
    unregister.current = null;
    videoRef.current = element;
    if (element) {
      setMuted(true);
      unregister.current = audioCoordinator.register(id, element, () => setMuted(true));
    }
  }, [id]);

  const toggleMute = () => {
    if (!videoRef.current?.muted) audioCoordinator.mute(id);
    else if (audioCoordinator.requestAudio(id)) setMuted(false);
  };
  return { videoRef, setVideoRef, isMuted, blocked: owner !== null, toggleMute };
}
